import BackendService from "./BackendService";

async function getOnlineOrders(params = {}) {
  return BackendService.getData("/online-orders/", {}, params);
}

async function getOnlineOrder(id) {
  return BackendService.getData(`/online-orders/${id}/`);
}

async function updateOnlineOrder(id, data) {
  return BackendService.patch(`/online-orders/${id}/`, data);
}

const OnlineOrderService = {
  getOnlineOrders,
  getOnlineOrder,
  updateOnlineOrder,
};

export default OnlineOrderService;
